import React from "react"
import ActionWrapper from "containers/ActionWrapper"
import WithData from "containers/WithData"
import Loaded from "./UserInfoRequests"
import Loading from "./UserInfoRequests.loading"
import glamorous from "glamorous"
import style from "utils/style"

class UserInfoRequests extends React.Component {
  render() {
    return (
      <ActionWrapper title="Information Requests">
        <WithData
          route={`info_requests?include=camp`}
          LoadingComponent={Loading}
        >
          <Loaded />
        </WithData>
      </ActionWrapper>
    )
  }
}

export default UserInfoRequests

export const ArchiveRequest = glamorous.button({
  background: style.colors.reddishOrange,
  fontSize: "0.8rem",
  color: "white",
  border: `1px solid ${style.colors.darkRed}`,
  borderRadius: 5,
  padding: 5,
  "&:hover": {
    cursor: "pointer",
  },
})



// WEBPACK FOOTER //
// ./src/scenes/User/UserInfoRequests/index.js